import React from "react";
import { connect } from "react-redux";

const LookSideBarAIPanelFinishedRenderContent = (props) => {

  const {lookAiRenderFinished, aiResults, isPhoneNumberValidated} = props;

  const activeResult = lookAiRenderFinished ? aiResults.find(aiResult => aiResult.isActive) : null;
  const showLeadOverlay = !isPhoneNumberValidated && !document.kvConfig.isBackend;

  return (
    <div className="look-ai__sidebar-content u-rounded-05 u-h-full bg-center bg-cover"
         style={activeResult && activeResult.resultImageUrl ? {backgroundImage: `url(${activeResult.resultImageUrl})`} : null}>
      {activeResult && activeResult.resultImageUrl && showLeadOverlay ?
        <div className="look-ai__overlay-blur bg-center bg-cover u-h-full look-ai__sidebar-content u-rounded-05"
             style={{backgroundImage: `url(${activeResult.resultImageUrl})`}}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookAiRenderFinished, aiResults} = store.aiState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    lookAiRenderFinished,
    aiResults,
    isPhoneNumberValidated,
  };
};

export default connect(mapStateToProps)(LookSideBarAIPanelFinishedRenderContent)
